import React from "react";
import * as RadioGroup from "@radix-ui/react-radio-group";
// import { styled } from "../stitches.config";

export interface Props extends RadioGroup.RadioGroupOwnProps {
  onChange?: (value: string) => void;
}

export function Radio({
  children,
  onChange,
  ...props
}: React.PropsWithChildren<Props>) {
  // Temporary because their API docs is out of sync with reality, onValueChange should be (v: string) => void
  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (onChange) onChange(e.target.value);
  }
  return (
    <RadioGroup.Root onValueChange={handleChange} {...props}>
      {children}
    </RadioGroup.Root>
  );
}

// export function RadioItem({
//   value,
//   ...props
// }: RadioGroup.RadioGroupItemOwnProps) {
//   return (
//     <Item {...props}>
//       <Indicator />
//       {value}
//     </Item>
//   );
// }

// export const Item = styled(RadioGroup.Item, {});

// export const Indicator = styled(RadioGroup.Indicator, {});
